import { render, staticRenderFns } from "./EditInsurance.vue?vue&type=template&id=91c77158"
import script from "./EditInsurance.vue?vue&type=script&lang=js"
export * from "./EditInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports